
import './StoreBookInsert.scss';
import * as S from '../scss/theme';
import fnc from '../mymod/commFunction';
import HongButton from '../comm/HongButton';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import StoreBookSidebar from './StoreBookSidebar';
import StoreBookModal from './StoreBookModal';
import { FaTag } from 'react-icons/fa';

const StoreBookInsert = ({ onBack }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [bookList, setBookList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [bookCategories, setBookCategories] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [selectedChildCode, setSelectedChildCode] = useState(null);
  const [rawData, setRawData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({
    sno: '',
    pCode: '',
    code: '',
    grade: '',
    title: '',
    publisher: '',
    price: '',
    imgFileName: '',
    imgFileName2: '',
    kuesbBookCode: '',
    content: '',
    useyn: 'Y'
  });

  const S3_BASE_URL = 'https://kuesb2.s3.ap-northeast-2.amazonaws.com/public/storeBook/';

  useEffect(() => {
    fetchStoreBookCategories();
  }, []);

  useEffect(() => {
    if (selectedChildCode) {
      fetchBookList(selectedChildCode);
    }
  }, [selectedChildCode]);

  const fetchStoreBookCategories = () => {
    fnc.sendAxios('/storeBookRoutes/select/storeBookList', {}, (res) => {
      if (res && res.length > 0) {
        setRawData(res);
        const grouped = groupDataByParent(res);
        setBookCategories(grouped);
        
        // 첫 번째 카테고리의 첫 번째 자식을 기본 선택
        if (grouped.length > 0) {
          setSelectedMenu(grouped[0].parent_code);
          if (grouped[0].children.length > 0) {
            setSelectedChildCode(grouped[0].children[0].child_code);
          }
        }
      }
    });
  };

  const groupDataByParent = (data) => {
    const parentMap = new Map();
    
    data.forEach(item => {
      if (!parentMap.has(item.parent_code)) {
        parentMap.set(item.parent_code, {
          parent_sno: item.parent_sno,
          parent_code: item.parent_code,
          parent_unit: item.parent_unit,
          grade: item.grade,
          icon: getIconByGrade(item.grade),
          children: []
        });
      }
      
      if (item.child_sno !== 'NULL' && item.child_sno !== null) {
        parentMap.get(item.parent_code).children.push({
          child_sno: item.child_sno,
          child_code: item.child_code,
          child_unit: item.child_unit,
          child_sort: item.child_sort
        });
      }
    });
    
    return Array.from(parentMap.values()).sort((a, b) => a.parent_sno - b.parent_sno);
  };

  const getIconByGrade = (grade) => {
    return <FaTag />;
  };

  const fetchBookList = (childCode) => {
    if (!childCode) {
      setBookList([]);
      return;
    }
    
    setIsLoading(true);
    fnc.sendAxios('/storeBookRoutes/select/storeBookList/detail', { pCode: childCode }, (res) => {
      if (res && res.length > 0) {
        setBookList(res);
      } else {
        setBookList([]);
      }
      setIsLoading(false);
    });
  };

  const handleChildMenuClick = (parentCode, childCode) => {
    setSelectedMenu(parentCode);
    setSelectedChildCode(childCode);
  };

  const handleEdit = (book) => {
    setFormData({
      sno: book.sno,
      pCode: book.pCode,
      code: book.code,
      grade: book.grade,
      title: book.title,
      publisher: book.publisher,
      price: book.price,
      imgFileName: book.imgFileName,
      imgFileName2: book.imgFileName2,
      kuesbBookCode: book.kuesbBookCode,
      content: book.content,
      useyn: book.useyn || 'Y'
    });
    setIsEditMode(true);
    setShowModal(true);
  };

  const handleDelete = (book) => {
    if (window.confirm(`${book.title} 교재를 삭제하시겠습니까?`)) {
      fnc.sendAxios('/storeBookRoutes/delete/bookDetail', { sno: book.sno }, (res) => {
        if (res.success) {
          alert('교재가 삭제되었습니다.');
          // 목록 새로고침
          if (selectedChildCode) {
            fetchBookList(selectedChildCode);
          }
        } else {
          alert('삭제에 실패했습니다.');
        }
      });
    }
  };

  const handleAddNew = () => {
    setFormData({
      sno: '',
      pCode: selectedChildCode || '',
      code: '',
      grade: '',
      title: '',
      publisher: '',
      price: '',
      imgFileName: '',
      imgFileName2: '',
      kuesbBookCode: '',
      content: '',
      useyn: 'Y'
    });
    setIsEditMode(false);
    setShowModal(true);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (imgFileName2) => {
    // imgFileName2가 전달되면 formData에 추가
    const dataToSubmit = imgFileName2 
      ? { ...formData, imgFileName2 } 
      : formData;

    // 유효성 검사
    if (!dataToSubmit.pCode || !dataToSubmit.code || !dataToSubmit.title) {
      alert('필수 항목을 입력해주세요. (카테고리, 코드, 제목)');
      return;
    }

    const endpoint = isEditMode 
      ? '/storeBookRoutes/update/bookDetail' 
      : '/storeBookRoutes/insert/bookDetail';

    fnc.sendAxios(endpoint, dataToSubmit, (res) => {
      if (res && res.success) {
        alert(isEditMode ? '교재가 수정되었습니다.' : '교재가 등록되었습니다.');
        setShowModal(false);
        setIsEditMode(false);
        // 목록 새로고침
        if (selectedChildCode) {
          fetchBookList(selectedChildCode);
        }
      } else {
        const errorMsg = isEditMode ? '수정에 실패했습니다.' : '등록에 실패했습니다.';
        alert(errorMsg + (res?.error ? '\n' + res.error : ''));
      }
    });
  };

  const handleCancel = () => {
    setShowModal(false);
    setIsEditMode(false);
  };




//=========================================
  return (
  <S.Section>
    <div className='StoreBookInsert'>
      <div className="insert-header">
        <div className="header-left"> 
          <h2>교재 등록 관리</h2>
        </div>

        <div className="header-right"> 
         <HongButton 
            className="btn h-btn-gray"
            iconType={'left'}
            onClick={onBack}
          >
            돌아가기
          </HongButton>

        <HongButton 
          className="btn h-btn-blue"
          iconType={'insert'}
          onClick={handleAddNew}
        >
          새 교재 등록
        </HongButton>

        </div>
      </div>

      <div className="insert-layout">
        {/* 사이드바 */}
        <StoreBookSidebar
          bookCategories={bookCategories}
          selectedMenu={selectedMenu}
          selectedChildCode={selectedChildCode}
          onChildMenuClick={handleChildMenuClick}
        />

        {/* 교재 테이블 */}
        <div className="insert-main">
          {isLoading ? (
            <div className="loading">
              <p>데이터 로딩 중...</p>
            </div>
          ) : (
            <div className="table-wrapper">
              <table className="table-hong book-table">
                <thead>
                  <tr>
                    <th>코드</th>
                    <th>학년</th>
                    <th>제목</th>
                     <th>내용</th>
                    <th>출판사</th>
                    <th>가격</th>
                    <th>본사교재코드</th>
                    <th>이미지</th>
                    <th>관리</th>
                  </tr>
                </thead>
                <tbody>
                  {bookList.length === 0 ? (
                    <tr>
                      <td colSpan="9" className="empty-row">
                        등록된 교재가 없습니다.
                      </td>
                    </tr>
                  ) : (
                    bookList.map((book) => (
                      <tr key={book.code}>
                        <td>{book.code}</td>
                        <td>{book.grade}</td>
                        <td className="title-cell">{book.title}</td>
                        <td className="content-cell">{book.content}</td>
                         <td>{book.publisher}</td>
                        <td className="price-cell">{Number(book.price).toLocaleString()}원</td>
                        <td>{book.kuesbBookCode}</td>
                        <td>{book.imgFileName}</td>
                        <td className="btn-cell">
                          <HongButton 
                            className="btn h-btn-white"
                            iconType={'update'}
                            iconPosition='center'
                            onClick={() => handleEdit(book)}
                          >
                            {/* 수정 */}
                          </HongButton>
                          <HongButton 
                            className="btn h-btn-white"
                            iconType={'delete'}
                            iconPosition='center'
                            onClick={() => handleDelete(book)}
                          >
                            {/* 삭제 */}
                          </HongButton>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* 등록/수정 모달 */}
      <StoreBookModal
        isOpen={showModal}
        isEditMode={isEditMode}
        formData={formData}
        onChange={handleFormChange}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </div>
  </S.Section>
  );
};

export default StoreBookInsert;